var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sip-home" },
    [
      _c("section", { staticClass: "sip-page-head" }, [
        _c("div", [
          _c("span", { staticClass: "sip-eyebrow" }, [_vm._v("Dashboard")]),
          _vm._v(" "),
          _c("h1", [_vm._v(_vm._s(_vm.trans("general.home")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n                Monitor tenant health, support queries, subscribers, and recent operations from one balanced admin workspace.\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sip-page-actions" },
          [
            _vm.hasPermission("list-query")
              ? _c(
                  "router-link",
                  { staticClass: "sip-btn", attrs: { to: "/query" } },
                  [_vm._v(_vm._s(_vm.trans("query.query")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasPermission("list-instance")
              ? _c(
                  "router-link",
                  {
                    staticClass: "sip-btn sip-btn--primary",
                    attrs: { to: "/instance" },
                  },
                  [_vm._v(_vm._s(_vm.trans("instance.instance")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      !_vm.hasPermission("list-instance")
        ? _c("div", { staticClass: "sip-surface-card sip-empty-state" }, [
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
            ]),
          ])
        : [
            _c(
              "section",
              {
                staticClass: "sip-metric-grid",
                attrs: { "aria-label": "Instance status summary" },
              },
              _vm._l(_vm.snapshotCards, function (item) {
                return _c(
                  "article",
                  {
                    key: item.key,
                    staticClass: "sip-surface-card sip-metric-card",
                    class: `sip-metric-card--${item.tone}`,
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item.label))]),
                    _vm._v(" "),
                    _c("strong", [_vm._v(_vm._s(item.value))]),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(item.caption))]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("section", { staticClass: "sip-content-grid" }, [
              _c(
                "article",
                { staticClass: "sip-surface-card sip-table-panel" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sip-section-head sip-section-head--with-actions",
                    },
                    [
                      _c("div", [
                        _c("span", [_vm._v("Instance status")]),
                        _vm._v(" "),
                        _c("h2", [
                          _vm._v(_vm._s(_vm.trans("instance.instance"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { staticClass: "sip-btn", attrs: { to: "/instance" } },
                        [_vm._v(_vm._s(_vm.trans("instance.instance")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sip-table-wrap" }, [
                    _c("table", { staticClass: "sip-data-table" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.instanceRows, function (row) {
                          return _c("tr", { key: row.key }, [
                            _c("td", [
                              _c("strong", [_vm._v(_vm._s(row.segment))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(row.caption))]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  staticClass: "sip-pill",
                                  class: `sip-pill--${row.tone}`,
                                },
                                [_vm._v(_vm._s(row.status))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(row.count))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(row.posture))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  staticClass: "sip-action-note",
                                  class: {
                                    "sip-action-note--muted": row.muted,
                                  },
                                },
                                [_vm._v(_vm._s(row.action))]
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("aside", { staticClass: "sip-support-column" }, [
                _vm.hasPermission("list-query")
                  ? _c(
                      "article",
                      { staticClass: "sip-surface-card sip-support-panel" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "sip-section-head sip-section-head--compact",
                          },
                          [
                            _c("div", [
                              _c("span", [_vm._v("Support queue")]),
                              _vm._v(" "),
                              _c("h2", [
                                _vm._v(_vm._s(_vm.trans("query.query"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("strong", { staticClass: "sip-resolved" }, [
                              _vm._v(
                                _vm._s(_vm.query_stats.resolved) + " resolved"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sip-support-card sip-support-card--summary",
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass: "sip-pill",
                                  class: _vm.queryHealthTone,
                                },
                                [_vm._v(_vm._s(_vm.queryHealthLabel))]
                              ),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.queryHealthTitle)),
                              ]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.queryHealthCopy))]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "sip-btn",
                                attrs: { to: "/query" },
                              },
                              [_vm._v(_vm._s(_vm.trans("query.query")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermission("list-subscriber")
                  ? _c(
                      "article",
                      { staticClass: "sip-surface-card sip-subscriber-card" },
                      [
                        _c("span", [_vm._v("Subscriber state")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sip-subscriber-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.subscriber_stats.subscribed)),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.trans("subscriber.subscribed"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sip-subscriber-line sip-subscriber-line--muted",
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.subscriber_stats.unsubscribed)),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.trans("subscriber.unsubscribed"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "article",
                  { staticClass: "sip-surface-card sip-chart-card" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sip-section-head sip-section-head--compact",
                      },
                      [
                        _c("div", [
                          _c("span", [_vm._v("Distribution")]),
                          _vm._v(" "),
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.trans("instance.instance")) + " status"
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.graph.instance_status.labels &&
                              _vm.graph.instance_status.labels.length,
                            expression:
                              "graph.instance_status.labels && graph.instance_status.labels.length",
                          },
                        ],
                        staticClass: "sip-chart-wrap",
                      },
                      [
                        _c("doughnut-graph", {
                          attrs: { graph: _vm.graph.instance_status },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.graph.instance_status.labels ||
                    !_vm.graph.instance_status.labels.length
                      ? _c("p", { staticClass: "sip-empty-inline" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.trans("general.no_result_found")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "sip-bottom-grid" }, [
              _c(
                "article",
                { staticClass: "sip-surface-card sip-activity-panel" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sip-section-head sip-section-head--compact",
                    },
                    [
                      _c("div", [
                        _c("span", [_vm._v("Activity")]),
                        _vm._v(" "),
                        _c("h2", [
                          _vm._v(_vm._s(_vm.trans("activity.activity_log"))),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.activity_logs.length
                    ? _c(
                        "ol",
                        { staticClass: "sip-timeline" },
                        _vm._l(
                          _vm.activity_logs.slice(0, 5),
                          function (activity_log) {
                            return _c("li", { key: activity_log.id }, [
                              _c("span", { attrs: { "aria-hidden": "true" } }),
                              _vm._v(" "),
                              _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.activityTitle(activity_log))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.activityUserName(activity_log)) +
                                      " · " +
                                      _vm._s(
                                        _vm._f("momentDateTime")(
                                          activity_log.created_at
                                        )
                                      )
                                  ),
                                ]),
                              ]),
                            ])
                          }
                        ),
                        0
                      )
                    : _c("p", { staticClass: "sip-empty-inline" }, [
                        _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "article",
                { staticClass: "sip-surface-card sip-todo-panel" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sip-section-head sip-section-head--compact",
                    },
                    [
                      _c("div", [
                        _c("span", [_vm._v("Todos")]),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.trans("todo.todo")))]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.todos.length
                    ? _c(
                        "div",
                        { staticClass: "sip-todo-list" },
                        _vm._l(_vm.todos.slice(0, 5), function (todo) {
                          return _c(
                            "label",
                            { key: todo.id, staticClass: "sip-todo" },
                            [
                              _c("input", {
                                attrs: { type: "checkbox", disabled: "" },
                                domProps: { checked: Boolean(todo.status) },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _c("strong", [_vm._v(_vm._s(todo.title))]),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(_vm._s(_vm._f("moment")(todo.date))),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _c("p", { staticClass: "sip-empty-inline" }, [
                        _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                      ]),
                ]
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Segment")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Count")]),
        _vm._v(" "),
        _c("th", [_vm._v("Posture")]),
        _vm._v(" "),
        _c("th", [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }